import { Text } from "@chakra-ui/react";

/** Matches section titles in CampaignMetricsCard, CampaignResultsCard (Headline). */
const HeadingStyles = {
  h1: {
    fontSize: "24px",
    fontWeight: "600",
    lineHeight: "120%",
    letterSpacing: "-0.72px",
    textAlign: "left" as const,
    verticalAlign: "middle",
    color: "#1A202C",
  },
  /** Matches ad set name in AdSetCards. */
  h2: {
    fontFamily: "Work Sans",
    fontSize: "18px",
    fontWeight: "600",
    lineHeight: "130%",
    letterSpacing: "0",
    verticalAlign: "middle",
    color: "gray.800",
  },
  /** Matches "Event" label in CampaignEventBlock (smaller heading). */
  h3: {
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "150%",
    letterSpacing: "-0.48px",
    textAlign: "left" as const,
    color: "gray.800",
  },
  /** Subheadline: Work Sans, muted color, 1rem, 500 weight. */
  subheadline: {
    fontFamily: "Work Sans",
    fontSize: "sm",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "150%",
    letterSpacing: "-0.03rem",
    textAlign: "left" as const,
    color: "rgba(26, 32, 44, 0.75)",
  },
};

const Heading = ({
  children,
  variant,
}: {
  children: React.ReactNode;
  variant: keyof typeof HeadingStyles;
}) => <Text {...HeadingStyles[variant]}>{children}</Text>;

export default Heading;
